import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M12 16h-1v-3a1 1 0 0 1 0-1l10-9h2l1 1a2 2 0 0 1 0 2l-9 10a1 1 0 0 1-1 0h-2ZM22 6l1-1-1-1-1 1 1 1ZM7 4l2 3 3 2-3 2-2 3-2-3-3-2 3-2 2-3ZM12 2l1 1 1 1-1 1-1 1-1-1-1-1 1-1 1-1Z"/>',
  f: '<path d="M12 16h-1v-3a1 1 0 0 1 0-1l10-9h2l1 1a2 2 0 0 1 0 2l-9 10a1 1 0 0 1-1 0h-2ZM22 6l1-1-1-1-1 1 1 1ZM7 4l2 3 3 2-3 2-2 3-2-3-3-2 3-2 2-3ZM12 2l1 1 1 1-1 1-1 1-1-1-1-1 1-1 1-1Z"/>',
  vb: '0 0 24 24',
};

export default data;
